module.exports = __webpack_public_path__ + "static/media/shipyard.a8926094.svg";